@if (tabs.length > 1 && number$ | async) {
    <div class="grid-page mx-sm-4 mt-3">
        <dx-tabs
            keyExpr="key"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [iconPosition]="'start'"
            (onItemClick)="selectedTab = $event.itemData.key"
            [scrollByContent]="true"
            [scrollingEnabled]="true"
            [showNavButtons]="false"></dx-tabs>
    </div>
} 

@if (selectedTab === 'details' && showDetails) {
    <app-invoice-purchase-order-details [number]="number$ | async"></app-invoice-purchase-order-details>
} @else if (selectedTab === 'history' && showHistory) {
    <app-invoice-purchase-order-history [number]="number$ | async"></app-invoice-purchase-order-history>
}